import ShortUniqueId from 'short-unique-id'
import { makePass } from '/providers/passes-api'
import _ from 'lodash'

import config from '/providers/config.json'

const batchSendMakePasses = async ({
  apiKey,
  apiSource,
  apiMode,
  templateId,
  dataSource,
  passData,
  variables,
  setMakePassResults,
  setPassesToProcess,
  batchSize = 10,
  onProgress,
}) => {
  try {

    let response = { ok: true }

    let data = dataSource === "upload" ? passData : [_.cloneDeep(variables)]

    // Add check here to see if we have enough capacity before we start...

    if (apiMode === "test") data = data.slice(0, config.maxTestPasses)

    let results = []
    let processedCount = 0

    setPassesToProcess(data.length)
    if (onProgress) onProgress({ total: data.length, processed: 0, remaining: data.length, failed: 0, succeeded: 0 })

    for (let d = 0; d < data.length; d += batchSize) {
      const chunk = data.slice(d, d + batchSize)
      const chunkResults = await Promise.all(chunk.map(item =>
        sendMakePass({ apiKey, apiSource, apiMode, templateId, variables: item })
      ))

      chunkResults.forEach(r => {
        if (!r.ok || r.error) {
          response = r
          results = [...results, {
            id: r.passId,
            error: r.error?.message ?? r.error
          }]
        } else {
          results = [...results, {
            id: r.pass_id,
            appleUrl: r.appleUrl,
            googleUrl: r.googleUrl,
          }]
        }
      })

      processedCount += chunk.length
      setMakePassResults(results)
      if (onProgress) {
        const failed = results.filter(r => r.error).length
        const succeeded = results.length - failed
        onProgress({
          total: data.length,
          processed: processedCount,
          remaining: Math.max(0, data.length - processedCount),
          failed,
          succeeded
        })
      }
    }

    return response
  }
  catch (err) {
    console.error(err)
  }
}

export default batchSendMakePasses


const sendMakePass = async ({ apiKey, apiSource, apiMode, templateId, variables }) => {
  const result = await makePass({ apiKey, apiSource, apiMode, templateId, variables})

  return result
}